export default __webpack_public_path__ + "static/userDummy4-e8e73be8644b6b979b291bbad1643f61.jpg";